import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import PositionsIssuersView from "@/features/R1Dashboard/views/PositionsIssuersView";

export default function R1PositionsIssuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions-Issuers");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <PositionsIssuersView />
      </main>
    </R1DashboardProvider>
  );
}
